<template>
  <div class="auth__login-container">
    <div class="auth__login__content">
      <div class="auth__login__brand-logo">
        <img src="/static/moneywave.png" width="220" height="auto" alt="Moneywave Logo" />
      </div>
      <div class="auth__login-form">
        <form action @submit.prevent="handlePasswordReset()">
          <div class="panel panel--login">
            <div class="panel__header">
              <div class="panel__header__left">
                Login to
                <span>Moneywave</span>
              </div>
              <div class="panel__header__right">
                <router-link
                  :to="{name: 'signup-personal'}"
                  class="btn btn--default"
                >Get a free account</router-link>
              </div>
            </div>
            <div class="panel__content">
              <!--email-->
              <div id="snackbar"></div>
              <div class="auth__login__item">
                <label for="authLoginEmail">
                  Your
                  <span>email</span>
                </label>
                <input
                  id="authLoginEmail"
                  type="email"
                  class="form__input"
                  v-model="email"
                  autocomplete="new-password"
                />
              </div>

              <div class="auth__login__item">
                <label for="authLoginEmail">
                  Your
                  <span>new Password</span>
                </label>
                <input
                  id="authLoginPassword"
                  type="password"
                  class="form__input"
                  v-model="password"
                  autocomplete="new-password"
                />
              </div>

              <div class="auth__login__item">
                <label for="authLoginEmail">
                  Confirm
                  <span>Password</span>
                </label>
                <input
                  id="authLoginConfrimPassword"
                  type="password"
                  class="form__input"
                  v-model="confirmPassword"
                  autocomplete="new-password"
                />
              </div>

              <!--error field-->
              <div class="form__errors" v-if="errorExists" v-for="error in errors">
                <div class="form__errors__icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="22"
                    height="20"
                    viewBox="0 0 22 20"
                  >
                    <defs>
                      <path
                        id="apiicon"
                        d="M10.47 0C4.697 0 0 4.486 0 10s4.697 10 10.47 10c5.773 0 10.47-4.486 10.47-10S16.243 0 10.47 0m0 18c-4.618 0-8.376-3.589-8.376-8s3.758-8 8.376-8c4.619 0 8.376 3.589 8.376 8s-3.757 8-8.376 8m0-13c-.578 0-1.047.447-1.047 1v4c0 .553.47 1 1.047 1 .578 0 1.047-.447 1.047-1V6c0-.553-.469-1-1.047-1m0 8c-.578 0-1.047.447-1.047 1 0 .553.47 1 1.047 1 .578 0 1.047-.447 1.047-1 0-.553-.469-1-1.047-1"
                      />
                    </defs>
                    <use
                      fill="#9C6F19"
                      fill-rule="evenodd"
                      transform="translate(.935)"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xlink:href="#apiicon"
                    />
                  </svg>
                </div>
                <div class="form__errors__text">{{error}}</div>
              </div>

              <!--submit form-->
              <div class="auth__login__item submit__login-form">
                <button
                  id="loginBtn"
                  type="submit"
                  class="btn btn--primary btn--block"
                >SET YOUR PASSWORD</button>
              </div>

              <!--forgotpassword-->
              <div class="auth__login__forgot-pass text-center">
                <router-link :to="{name: 'login'}" class="link">
                  Login
                  <span>to Moneywave</span>
                </router-link>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "./../../assets/stylesheets/scss/auth";
</style>

<script>
import { reset } from "../../utils/auth/authService";
import router from "../../router";
import { getUser } from "../../utils/user/getUserDetails";
import { mapState } from "vuex";
import { mapGetters } from "vuex";

export default {
  mounted() {
    if (!this.$route.query.token) {
      document.getElementById("loginBtn").disabled = true;
      this.errors = [];
      this.errorExists = true;
      this.errors.push(
        "Token is missing, kindly re-confirm the link that was sent"
      );
    }
  },
  name: "Login",
  data() {
    return {
      isLoggedIn: false,
      userPassword: "",
      errors: [],
      errorExists: false,
      email: "",
      password: "",
      confirmPassword: ""
    };
  },

  computed: {
    getEmail: {
      get() {
        if (this.$store.state.authUser.email === "") {
          return this.$store.state.isUser.email;
        } else {
          return this.$store.state.authUser.email;
        }
      },
      set(value) {
        return this.$store.commit("updateUserEmail", value);
      }
    }
  },

  methods: {
    handlePasswordReset() {
      document.getElementById("loginBtn").disabled = true;
      if (
        this.email !== "" &&
        this.password !== "" &&
        this.confirmPassword !== ""
      ) {
        this.$Progress.start();
        if (this.password === this.confirmPassword) {
          reset(this.email, this.password, this.$route.query.token)
            .then(response => {
              if (response.status === 200) {
                if (response.data.data.status === "completed") {
                  this.$Progress.finish();
                  this.errorExists = false;
                  this.errors = [];
                  this.showSnackbar(
                    "You have successfully reset your password"
                  );
                } else {
                  this.$Progress.fail();
                  this.errorExists = true;
                  this.errors = [];
                  this.errors.push(
                    "There was an error resetting your password, please try again"
                  );
                  document.getElementById("loginBtn").disabled = false;
                }
                // if(response.data.data.notified){
                //     if(JSON.parse(response.data.data.notified.m).data.code === '00'){
                //         this.$Progress.finish();
                //         this.showSnackbar("A reset link has been sent to the email")
                //     }
                //     else if(JSON.parse(response.data.data.notified.m).data.code !== '00'){
                //         this.$Progress.finish();
                //         this.$Progress.fail();
                //         this.errorExists = true;
                //         this.errors = [];
                //         this.errors.push('There was an error sending the link, please try again');
                //         document.getElementById('loginBtn').disabled = false;
                //     }
                // }
                // else {
                //     this.$Progress.finish();
                //     this.$Progress.fail();
                //     this.errorExists = true;
                //     this.errors = [];
                //     this.errors.push('Email does not exist');
                //     document.getElementById('loginBtn').disabled = false;
                // }
              }
            })
            .catch(error => {
              document.getElementById("loginBtn").disabled = false;
              this.$Progress.fail();
              this.errorExists = true;
              this.errors = [];
              this.errors.push(error.response.data.message);
              console.log(error.response.data.message);
            });
        } else {
          this.$Progress.finish();
          this.$Progress.fail();
          this.errorExists = true;
          this.errors = [];
          this.errors.push("Your password has to match");
          document.getElementById("loginBtn").disabled = false;
        }
      } else {
        this.$Progress.fail();
        document.getElementById("loginBtn").disabled = false;
        this.errorExists = true;
        let error = "Please fill all fields";
        this.errors = [];
        this.errors.push(error);
      }
    },
    showSnackbar(text) {
      let snackbar = document.getElementById("snackbar");
      snackbar.innerHTML = text;
      snackbar.className = "show";

      setTimeout(function() {
        snackbar.className = snackbar.className.replace("show", "");
        router.push("login");
      }, 3500);
    }
  }
};
</script>

<style scoped>
#snackbar {
  visibility: hidden;
  /*poisition: fixed;*/
  top: 0px;
  background-color: deepskyblue;
  color: white;
  padding: 5px;
  text-align: center;
}

#snackbar.show {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/resetPasswordPage.vue